import React from "react";
import { useSearchParams } from "react-router-dom";
import Services from "../components/Services";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ServiceHeader from "../components/ServiceHeader";
import hero_img from "../static/img/service_header.jpg";
import service1 from "../static/img/service1.png";
import service2 from "../static/img/service2.jpeg";
import service3 from "../static/img/service3.jpeg";
import service4 from "../static/img/service4.jpeg";
import "../static/css/ServiceDetail.css";

function ServicePage() {
  const [searchParams] = useSearchParams();
  const serviceIndex = searchParams.get("service");

  const servicesData = [
    {
      img: service1,
      title: "Insolvency & Bankruptcy Service",
      description: "Comprehensive insolvency and restructuring services across CIRP, liquidation, individual insolvency, forensic audits, and resolution planning.",
      details: [
        "Corporate Insolvency Resolution Process (CIRP)",
        "Liquidation Management",
        "Individual Insolvency Services (for personal guarantors)",
        "Bankruptcy Trustee Services (for personal guarantors)",
        "Going Concern Sales & Asset Realization",
        "Information Memorandum Preparation",
        "Resolution Plan / Repayment Plan Preparation",
        "IBC Consultation"
      ]
    },
    {
      img: service2,
      title: "Audit & Assurance",
      description: "Professional auditing and assurance services to ensure accuracy, compliance, and integrity in financial reporting.",
      details: [
        "Transaction Audits",
        "Forensic Audits",
        "Due Diligence Reviews",
        "Statutory Audits"
      ]
    },
    {
      img: service3,
      title: "Corporate Stress & Turnaround",
      description: "Strategic solutions for distressed businesses focusing on rehabilitation, restructuring, and revival.",
      details: [
        "Stressed Asset Rehabilitation",
        "Business Process Re-engineering",
        "Financial Restructuring",
        "Revival of Sick Units (Pre-IBC & IEC)",
        "OTS & CDR Scheme Facilitation"
      ]
    },
    {
      img: service4,
      title: "Financial Advisory",
      description: "Expert financial guidance and strategic planning for mergers, acquisitions, restructuring, and investment coordination.",
      details: [
        "Mergers & Acquisitions (M&A)",
        "Corporate Restructuring",
        "Investor Identification & Coordination",
        "FDI Facilitation"
      ]
    }
  ];

  // If a specific service is selected, show details
  if (serviceIndex !== null && servicesData[serviceIndex]) {
    const service = servicesData[serviceIndex];

    return (
      <>
        <Nav />
        <ServiceHeader
          image={service.img}
          title={service.title}
          description={service.description}
        />
        <div className="service-detail-container">
          <div className="service-detail-content">
            <h2>Our Services Include:</h2>
            <ul className="service-detail-list">
              {service.details.map((detail, index) => (
                <li key={index}>• {detail}</li>
              ))}
            </ul>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // Otherwise, show all services
  return (
    <>
      <Nav />
      <div className="hero-img">
        <img src={hero_img} alt="Hero Img" />
      </div>
      <Services />
      <Footer />
    </>
  );
}

export default ServicePage;

